import { render } from "./withdraw-add.vue?vue&type=template&id=c02b4b78&scoped=true"
import script from "./withdraw-add.vue?vue&type=script&lang=js"
export * from "./withdraw-add.vue?vue&type=script&lang=js"

import "./withdraw-add.vue?vue&type=style&index=0&id=c02b4b78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02b4b78"]])

export default __exports__